import { SystemStyleObject } from '@chakra-ui/react'

export const cardGroupContainerStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'stretch',
  width: 'full',
}
